<template>
      <div id="hpn-app">
            <TopBar />
            <transition name="router-anim" enter-active-class="animate__animated animate__fadeIn animate__faster" leave-active-class="animate__animated animate__fadeOut animate__faster" mode="out-in">
                  <router-view />
            </transition>
      </div>
</template>

<script>
      import TopBar from "./components/TopBar"
      export default {
            name: "Anthem",
            components: {
                  TopBar
            }
      };
</script>

<style lang="scss">
      @font-face {
            font-family: "TV Nord EF";
            font-weight: 300;
            src: url("/fonts/TVNordEF-Light.ttf");
      }
      @font-face {
            font-family: "TV Nord EF";
            font-weight: normal;
            src: url("/fonts/TVNordEF-Regular.ttf");
      }
      @font-face {
            font-family: "TV Nord EF";
            font-weight: 600;
            src: url("/fonts/TVNordEF-Bold.ttf");
      }
      body{
            font-family: "TV Nord EF", "Helvetica Neue", Arial, sans-serif !important;
            font-weight: normal !important;
      }
      h1, h2, h3, h4, h5, h6{
            font-family: "TV Nord EF", "Helvetica Neue", Arial, sans-serif !important;
            margin-bottom:32px !important;
            font-size: 38px !important;
            font-weight: 600;
      }
      p{
            margin-bottom:48px !important;
      }
      a{
            transition: all 0.2s ease-in-out 0s;
      }
      sup{
            top:-.9em !important;
      }
      sub, sup {
            font-size: 50% !important;
      }
      .fa, .fas, .far{
            font-family: "Font Awesome 5 Free";
            font-weight: 900;
      }
     
      .text-left{
            text-align: left !important;
      }
      .mb0{
            margin-bottom: 0px !important;
      }
      .mb4{
            margin-bottom: 4px !important;
      }
      .mb8{
            margin-bottom: 8px !important;
      }
      .mb12{
            margin-bottom: 12px !important;
      }
      .mb16{
            margin-bottom: 16px !important;
      }
      .mb24{
            margin-bottom: 24px !important;
      }
      .mb32{
            margin-bottom: 32px !important;
      }
      .mb40{
            margin-bottom: 40px !important;
      }
      .mb48{
            margin-bottom: 48px !important;
      }
      .mb64{
            margin-bottom: 64px !important;
      }
      .mb80{
            margin-bottom: 80px !important;
      }
      .mb96{
            margin-bottom: 96px !important;
      }
      
      .mt32{
            margin-top: 32px !important;
      }
      .mt40{
            margin-top: 40px !important;
      }
      #hpn-app{
            .grid-container{
                  max-width: 90rem; // NEW STYLE
            }
            .button{
                  margin-bottom: 0;
                  border-radius: 0px;
                  font-weight: 600;
                  font-size: 1.125rem;
                  transition: all 0.2s ease-in-out 0s;
                  padding: .6em .4em .5em;
                  &.anthem-btn{
                        color: #ffffff;
                        background-color: rgba(243, 128, 33, 1);
                        &:hover{
                              background-color: rgba(243, 128, 33, 0.8);
                        }
                  }
                  &.hollow{
                        color:#58b6e7;
                        border-color: #58b6e7;
                        &:hover{
                              color:#0079c2;
                              border-color: #0079c2;
                        }
                  }
            }
      }
</style>
